module.exports = __webpack_public_path__ + "static/img/wuhanwei.a597ce8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wuhanwei.png
// module id = O4jc
// module chunks = 1